import type { ChatFeedbackRequest } from "@/clients/models/ChatFeedbackRequest";
import { ChatFeedbackService } from "@/clients/services/ChatFeedbackService";
import { useMutation } from "@tanstack/react-query";

/** POST /api/v1/chat/feedback — submits thumb up/down on a specific
 *  assistant message. The caller is responsible for de-duping (only fire
 *  when the rating actually changes) since there's no server-side dedupe. */
export const useSubmitChatFeedback = () =>
  useMutation({
    mutationFn: (body: ChatFeedbackRequest) =>
      ChatFeedbackService.submitChatFeedbackApiV1ChatFeedbackPost(body),
  });
